import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './individual-meter-water-meter-hot-lg.svg';
import md from './individual-meter-water-meter-hot-md.svg';
import sm from './individual-meter-water-meter-hot-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.INDIVIDUAL_METER_WATER_METER_HOT,
  label: 'Individueller_Warmwasserzähler',
  shortLabel: 'Ind_Warmw',
  icons: { sm, md, lg },
  component: component('individual-meter-water-meter-hot/IndividualMeterHotWaterMeterDevicePanel.vue'),
  props: { volumeColor: 'RED' },
  aggregationWidget: {
    enabled: true,
    component: component('individual-meter-water-meter-hot/IndividualMeterHotWaterMeterAggregationWidget.vue'),
    props: { digitColor: 'RED' },
  },
  defaultMetricNames: ['currentVolume'],
  importantMetricNames: ['currentVolume', 'currentFlow'],
  aggregationMetricNames: [
    {
      name: 'currentVolume',
      aggregators: [MetricResolutionAggregator.SUM],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
  consumption: true,
}));
